import { useApp } from '../store.js';

const TABS = [
  { view: null, icon: '🏠', label: 'Главная' },
  { view: 'shop', icon: '🛍', label: 'Магазин' },
  { view: 'referrals', icon: '🎁', label: 'Друзья' },
  { view: 'leaderboard', icon: '🏅', label: 'Лидеры' },
] as const;

/** Нижняя навигация: главная, магазин, лидеры. */
export function BottomNav() {
  const view = useApp((s) => s.view);
  const setView = useApp((s) => s.setView);
  const current = view === 'profile' ? null : view;
  return (
    <nav className="bottom-nav" aria-label="Разделы">
      {TABS.map((t) => (
        <button
          key={t.label}
          type="button"
          className={`bottom-nav__tab ${current === t.view ? 'bottom-nav__tab--on' : ''}`}
          aria-current={current === t.view ? 'page' : undefined}
          onClick={() => setView(t.view)}
        >
          <span aria-hidden="true">{t.icon}</span>
          {t.label}
        </button>
      ))}
    </nav>
  );
}
